export var ActivityValidationStates;
(function (ActivityValidationStates) {
    ActivityValidationStates["NOT_PASSED"] = "NotPassed";
    ActivityValidationStates["PARTIALLY_PASSED"] = "PartiallyPassed";
    ActivityValidationStates["PASSED"] = "Passed";
    ActivityValidationStates["PENDING"] = "Pending";
    ActivityValidationStates["DECLINED"] = "Declined";
})(ActivityValidationStates || (ActivityValidationStates = {}));
